module.exports = __webpack_public_path__ + "img/SiGe-plunger.757a1304.svg";